<template>
  <!-- Employee List Component With All, Pending and Rejected Employees Component -->
  <div class="tabs-content-firstblock px-6">
    <div class="row">
      <div class="col-lg-12 pr-0 pl-0">
        <div class="preview-elements adminview">
          <ul
            class="nav nav-pills nav-employees d-flex align-items-center ml-3 pt-3 pb-0"
            id="myTab"
            role="tablist"
          >
            <li class="nav-item d-flex align-items-center">
              <el-dropdown trigger="click" style="font-weight: 700; font-size: 16px">
                <span class="el-dropdown-link">
                  {{ selectedTab }}
                  <img src="/static/images/downarrow.svg" class="ml-5" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <a
                      @click="clearSearchKey();selectedTab='All Employees'"
                      class="nav-link"
                    >All Employees</a>
                    <a
                      @click="clearSearchKey();selectedTab='Pending Invites'"
                      class="nav-link"
                    >Pending Invites</a>
                    <a
                      v-if="account==$route.params.id && (admin || superAdmin)"
                      @click="clearSearchKey();selectedTab='Rejected Invites'"
                      class="nav-link"
                    >Rejected Invites</a>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <div class="d-flex mx-2">
                <i
                  class="icon icon-magnify icondefault"
                  style="font-size: 16px; font-weight: 600; padding-left: 6px;"
                  @click="showSearch = !showSearch"
                ></i>
              </div>
              <div class="d-flex mx-1" v-if="showSearch">
                <input
                  type="text"
                  @keyup="searchEmployees"
                  v-model="searchKey"
                  placeholder="Search Employees"
                  style="color: #303031; width: 14em; border-radius: 20px 0px 0px 20px; padding-left: 20px;"
                />
                <i
                  class="icon icon-magnify icondefault"
                  style="border-radius: 0px 20px 20px 0px"
                ></i>
              </div>
            </li>
            <span style="margin-left: auto;display: inline-block;">
              <li class="nav-item d-flex align-items-center">
                <div class="dropdown mx-1">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    v-if="account==$route.params.id && (admin || superAdmin)"
                    content="Add New Employee"
                    placement="bottom"
                  >
                    <div
                      class="dropdown-toggle employee-toggle pointer btn btn-link d-flex align-items-center"
                      role="button"
                      id="dropdownShortcutMenu"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      @click="$router.push('/addEmployee')"
                      style="padding: 0px;min-width:1.4rem;"
                    >
                      <i class="icon icon-account-plus icondefault"></i>
                    </div>
                  </el-tooltip>
                </div>
                <div v-if="show == 'grid' && selectedTab == 'All Employees'" class="white-box-header mx-1" @click="toggleview">
                  <img src="/static/icons/crm/list.svg" alt="grid" width="30" height="30" />
                </div>
                <div v-if="show == 'list' && selectedTab == 'All Employees'" class="white-box-header mx-1" @click="toggleview">
                  <img src="/static/icons/crm/grid.svg" alt="grid" width="16" height="16" />
                </div>
                <div class="white-box-header mx-1" @click="previousPage()">
                  <el-tooltip
                    class="item pull-right"
                    effect="dark"
                    content="Previous"
                    placement="top"
                  >
                    <img src="/static/icons/crm/backwardIcon.svg" alt="back" width="30" height="30" />
                  </el-tooltip>
                </div>
                <div class="white-box-header mx-1" @click="nextPage()">
                  <el-tooltip class="item pull-right" effect="dark" content="Next" placement="top">
                    <img src="/static/icons/crm/forwardIcon.svg" alt="back" width="30" height="30" />
                  </el-tooltip>
                </div>
              </li>
            </span>
          </ul>
          <div class="tab-content employee-tab-content pt-0 pb-3" id="myTabContent">
            <div v-if="selectedTab == 'All Employees'">
              <all-employees></all-employees>
            </div>
            <div v-if="selectedTab == 'Pending Invites'">
              <pending-invites></pending-invites>
            </div>
            <div v-if="selectedTab == 'Rejected Invites'">
              <rejected-invites></rejected-invites>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { User } from "./mixins/user";
// import { EmployeeManage } from "./mixins/employees";
import AllEmployees from "./AllEmployees";
import PendingInvites from "./PendingInvites";
import RejectedInvites from "./RejectedInvites";
import { EventBus } from "./eventBus/nav-bar-event.js";

export default {
  data() {
    return {
      userSearchKey: "",
      searchKey: "",
      employeeData: [],
      userSearchData: {},
      employeeDataCount: 1,
      selectedTab: "All Employees",
      show: "grid",
      showSearch: false,
    };
  },
  mixins: [User],
  methods: {
    // Go to Employee Profile
    gotoUser(user_id) {
      this.$router.push({ name: "AccountProfile", params: { id: user_id } });
    },
    // Add Employee Component
    goToAddEmployee() {
      this.$router.push({ name: "AddEmployee" });
    },
    // Search Users API
    searchUsers() {
      // To search users not in company
      this.$http
        .post("/employees/search_users_not_in_company", {
          search_key: this.userSearchKey,
          skip: this.skip,
          limit: this.limit,
        })
        .then(response => {
          if (response.data.status_id == 1) {
            this.userSearchData = response.data.response;
          }
        })
        .catch(error => {
        });
    },
    clearEmployeeData() {
      this.employeeData = [];
    },
    clearSearch() {
      (this.userSearchKey = ""), this.searchUsers();
    },
    clearSearchKey() {
      this.searchKey = "";
      EventBus.$emit("clearKey", this.searchKey);
      this.userSearchKey = "";
    },
    // addEmployee() {
    //   //this.$modal.show("add-employee-modal")
    //   this.$router.push("/addemployee");
    // },
    toggleview() {
      if (this.show == "grid") {
        this.show = "list";
      } else {
        this.show = "grid";
      }
      localStorage.setItem("show", this.show);
      EventBus.$emit("toggleview", this.show);
    },
    previousPage() {
      EventBus.$emit("previouspage");
    },
    nextPage() {
      EventBus.$emit("nextpage");
    },
    searchEmployees() {
      EventBus.$emit("searchemployees", this.searchKey);
    },
  },
  mounted() {
    $(".dropdown-menu.dropdown-employee").click(function(e) {
      e.stopPropagation();
    });
  },
  destroyed() {
    localStorage.clear();
  },
  components: {
    AllEmployees,
    PendingInvites,
    RejectedInvites,
  },
  created() {
    this.searchUsers();
  },
  computed: {
    account() {
      return this.$store.getters.account;
    },
    admin() {
      return this.$store.getters.isAdmin;
    },
    superAdmin() {
      return this.$store.getters.isSuperAdmin;
    },
  },
};
</script>
<style scoped>
.blue-border-box {
  border: dashed 0px transparent;
  padding: 11px 20px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.92;
  letter-spacing: 0.56px;
  text-align: center;
  color: #00448b;
  width: 265px;
  margin: 0 auto;
  border-radius: 12px;
}
.uk-grid {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  list-style: none;
}
.uk-grid:after,
.uk-grid:before {
  content: "";
  display: block;
  overflow: hidden;
}
.uk-grid:after {
  clear: both;
}
.uk-grid > * {
  -ms-flex: none;
  -webkit-flex: none;
  flex: none;
  margin: 0;
  float: left;
}
.uk-grid > * > :last-child {
  margin-bottom: 0;
}
/* .uk-grid {
  margin-left: -25px;
} */
.uk-grid > * {
  padding-left: 25px;
}
.uk-grid + .uk-grid,
.uk-grid-margin,
.uk-grid > * > .uk-panel + .uk-panel {
  margin-top: 25px;
}
@media (min-width: 1220px) {
  .uk-grid {
    margin-left: -35px;
  }
  .uk-grid > * {
    padding-left: 35px;
  }
  .uk-grid + .uk-grid,
  .uk-grid-margin,
  .uk-grid > * > .uk-panel + .uk-panel {
    margin-top: 35px;
  }
}
.uk-grid-collapse {
  margin-left: 0;
}
.uk-grid-collapse > * {
  padding-left: 0;
}
.uk-grid-collapse + .uk-grid-collapse,
.uk-grid-collapse > * > .uk-panel + .uk-panel,
.uk-grid-collapse > .uk-grid-margin {
  margin-top: 0;
}
.uk-grid-small {
  margin-left: -10px;
}
.uk-grid-small > * {
  padding-left: 10px;
}
.uk-grid-small + .uk-grid-small,
.uk-grid-small > * > .uk-panel + .uk-panel,
.uk-grid-small > .uk-grid-margin {
  margin-top: 10px;
}
.uk-grid-medium {
  margin-left: -25px;
}
.uk-grid-medium > * {
  padding-left: 25px;
}
.uk-grid-medium + .uk-grid-medium,
.uk-grid-medium > * > .uk-panel + .uk-panel,
.uk-grid-medium > .uk-grid-margin {
  margin-top: 25px;
}
@media (min-width: 960px) {
  .uk-grid-large {
    margin-left: -35px;
  }
  .uk-grid-large > * {
    padding-left: 35px;
  }
  .uk-grid-large + .uk-grid-large,
  .uk-grid-large-margin,
  .uk-grid-large > * > .uk-panel + .uk-panel {
    margin-top: 35px;
  }
}
@media (min-width: 1220px) {
  .uk-grid-large {
    margin-left: -50px;
  }
  .uk-grid-large > * {
    padding-left: 50px;
  }
  .uk-grid-large + .uk-grid-large,
  .uk-grid-large-margin,
  .uk-grid-large > * > .uk-panel + .uk-panel {
    margin-top: 50px;
  }
}
.uk-grid-divider:not(:empty) {
  margin-left: -25px;
  margin-right: -25px;
}
.uk-grid-divider > * {
  padding-left: 25px;
  padding-right: 25px;
}
.uk-grid-divider > [class*="uk-width-9-"]:nth-child(n + 2),
.uk-grid-divider > [class*="uk-width-1-"]:not(.uk-width-1-1):nth-child(n + 2),
.uk-grid-divider > [class*="uk-width-2-"]:nth-child(n + 2),
.uk-grid-divider > [class*="uk-width-3-"]:nth-child(n + 2),
.uk-grid-divider > [class*="uk-width-4-"]:nth-child(n + 2),
.uk-grid-divider > [class*="uk-width-5-"]:nth-child(n + 2),
.uk-grid-divider > [class*="uk-width-6-"]:nth-child(n + 2),
.uk-grid-divider > [class*="uk-width-7-"]:nth-child(n + 2),
.uk-grid-divider > [class*="uk-width-8-"]:nth-child(n + 2) {
  border-left: 1px solid #ddd;
}
@media (min-width: 768px) {
  .uk-grid-divider
    > [class*="uk-width-medium-"]:not(.uk-width-medium-1-1):nth-child(n + 2) {
    border-left: 1px solid #ddd;
  }
}
@media (min-width: 960px) {
  .uk-grid-divider
    > [class*="uk-width-large-"]:not(.uk-width-large-1-1):nth-child(n + 2) {
    border-left: 1px solid #ddd;
  }
}
@media (min-width: 1220px) {
  .uk-grid-divider:not(:empty) {
    margin-left: -35px;
    margin-right: -35px;
  }
  .uk-grid-divider > * {
    padding-left: 35px;
    padding-right: 35px;
  }
  .uk-grid-divider:empty {
    margin-top: 35px;
    margin-bottom: 35px;
  }
}
.uk-grid-divider:empty {
  margin-top: 25px;
  margin-bottom: 25px;
  border-top: 1px solid #ddd;
}
.uk-grid-match > * {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
}
.uk-grid-match > * > * {
  -ms-flex: none;
  -webkit-flex: none;
  flex: none;
  box-sizing: border-box;
  width: 100%;
}
/* [class*=uk-grid-width]>*{
    box-sizing:border-box;
    width:100%
} */
.uk-grid-width-1-2 > * {
  width: 50%;
}
.uk-grid-width-1-3 > * {
  width: 33.333%;
}
.uk-grid-width-1-4 > * {
  width: 25%;
}
.uk-grid-width-1-5 > * {
  width: 20%;
}
.uk-grid-width-1-6 > * {
  width: 16.666%;
}
.uk-grid-width-1-10 > * {
  width: 10%;
}
.uk-grid-width-auto > * {
  width: auto;
}
@media (min-width: 480px) {
  .uk-grid-width-small-1-1 > * {
    width: 100%;
  }
  .uk-grid-width-small-1-2 > * {
    width: 100%;
  }
  .uk-grid-width-small-1-3 > * {
    width: 33.333%;
  }
  .uk-grid-width-small-1-4 > * {
    width: 25%;
  }
  .uk-grid-width-small-1-5 > * {
    width: 20%;
  }
  .uk-grid-width-small-1-6 > * {
    width: 16.666%;
  }
  .uk-grid-width-small-1-10 > * {
    width: 10%;
  }
}
@media (min-width: 768px) {
  .uk-grid-width-medium-1-1 > * {
    width: 100%;
  }
  .uk-grid-width-medium-1-2 > * {
    width: 50%;
  }
  .uk-grid-width-medium-1-3 > * {
    width: 49.333%;
  }
  .uk-grid-width-medium-1-4 > * {
    width: 25%;
  }
  .uk-grid-width-medium-1-5 > * {
    width: 20%;
  }
  .uk-grid-width-medium-1-6 > * {
    width: 16.666%;
  }
  .uk-grid-width-medium-1-10 > * {
    width: 10%;
  }
}
@media (min-width: 960px) {
  .uk-grid-width-large-1-1 > * {
    width: 100%;
  }
  .uk-grid-width-large-1-2 > * {
    width: 50%;
  }
  .uk-grid-width-large-1-3 > * {
    width: 33.333%;
  }
  .uk-grid-width-large-1-4 > * {
    width: 25%;
  }
  .uk-grid-width-large-1-32 > * {
    width: 32%;
  }
  .uk-grid-width-large-1-5 > * {
    width: 20%;
  }
  .uk-grid-width-large-1-6 > * {
    width: 16.666%;
  }
  .uk-grid-width-large-1-10 > * {
    width: 10%;
  }
}
@media (min-width: 1220px) {
  .uk-grid-width-xlarge-1-1 > * {
    width: 100%;
  }
  .uk-grid-width-xlarge-1-2 > * {
    width: 50%;
  }
  .uk-grid-width-xlarge-1-3 > * {
    width: 33.333%;
  }
  .uk-grid-width-xlarge-1-4 > * {
    width: 25%;
  }
  .uk-grid-width-xlarge-1-5 > * {
    width: 20%;
  }
  .uk-grid-width-xlarge-1-24 > * {
    width: 24%;
  }
  .uk-grid-width-xlarge-1-6 > * {
    width: 16.666%;
  }
  .uk-grid-width-xlarge-1-16 > * {
    width: 16% !important;
  }
  .uk-grid-width-xlarge-1-10 > * {
    width: 10%;
  }
}
[class*="uk-width"] {
  box-sizing: border-box;
  width: 100%;
}
.uk-width-1-1 {
  width: 100%;
}
.uk-width-1-2,
.uk-width-2-4,
.uk-width-3-6,
.uk-width-5-10 {
  width: 50%;
}
.uk-width-1-3,
.uk-width-2-6 {
  width: 33.333%;
}
.uk-width-2-3,
.uk-width-4-6 {
  width: 66.666%;
}
.uk-width-1-4 {
  width: 25%;
}
.uk-width-3-4 {
  width: 75%;
}
.uk-width-1-5,
.uk-width-2-10 {
  width: 20%;
}
.uk-width-2-5,
.uk-width-4-10 {
  width: 40%;
}
.uk-width-3-5,
.uk-width-6-10 {
  width: 60%;
}
.uk-width-4-5,
.uk-width-8-10 {
  width: 80%;
}
.uk-width-1-6 {
  width: 16.666%;
}
.uk-width-5-6 {
  width: 83.333%;
}
.uk-width-1-10 {
  width: 10%;
}
.uk-width-3-10 {
  width: 30%;
}
.uk-width-7-10 {
  width: 70%;
}
.uk-width-9-10 {
  width: 90%;
}
@media (min-width: 480px) {
  .uk-width-small-1-1 {
    width: 100%;
  }
  .uk-width-small-1-2,
  .uk-width-small-2-4,
  .uk-width-small-3-6,
  .uk-width-small-5-10 {
    width: 50%;
  }
  .uk-width-small-1-3,
  .uk-width-small-2-6 {
    width: 33.333%;
  }
  .uk-width-small-2-3,
  .uk-width-small-4-6 {
    width: 66.666%;
  }
  .uk-width-small-1-4 {
    width: 25%;
  }
  .uk-width-small-3-4 {
    width: 75%;
  }
  .uk-width-small-1-5,
  .uk-width-small-2-10 {
    width: 20%;
  }
  .uk-width-small-2-5,
  .uk-width-small-4-10 {
    width: 40%;
  }
  .uk-width-small-3-5,
  .uk-width-small-6-10 {
    width: 60%;
  }
  .uk-width-small-4-5,
  .uk-width-small-8-10 {
    width: 80%;
  }
  .uk-width-small-1-6 {
    width: 16.666%;
  }
  .uk-width-small-5-6 {
    width: 83.333%;
  }
  .uk-width-small-1-10 {
    width: 10%;
  }
  .uk-width-small-3-10 {
    width: 30%;
  }
  .uk-width-small-7-10 {
    width: 70%;
  }
  .uk-width-small-9-10 {
    width: 90%;
  }
}
@media (min-width: 768px) {
  .uk-width-medium-1-1 {
    width: 100%;
  }
  .uk-width-medium-1-2,
  .uk-width-medium-2-4,
  .uk-width-medium-3-6,
  .uk-width-medium-5-10 {
    width: 50%;
  }
  .uk-width-medium-1-3,
  .uk-width-medium-2-6 {
    width: 33.333%;
  }
  .uk-width-medium-2-3,
  .uk-width-medium-4-6 {
    width: 66.666%;
  }
  .uk-width-medium-1-4 {
    width: 25%;
  }
  .uk-width-medium-3-4 {
    width: 75%;
  }
  .uk-width-medium-1-5,
  .uk-width-medium-2-10 {
    width: 20%;
  }
  .uk-width-medium-2-5,
  .uk-width-medium-4-10 {
    width: 40%;
  }
  .uk-width-medium-3-5,
  .uk-width-medium-6-10 {
    width: 60%;
  }
  .uk-width-medium-4-5,
  .uk-width-medium-8-10 {
    width: 80%;
  }
  .uk-width-medium-1-6 {
    width: 16.666%;
  }
  .uk-width-medium-5-6 {
    width: 83.333%;
  }
  .uk-width-medium-1-10 {
    width: 10%;
  }
  .uk-width-medium-3-10 {
    width: 30%;
  }
  .uk-width-medium-7-10 {
    width: 70%;
  }
  .uk-width-medium-9-10 {
    width: 90%;
  }
}
@media (min-width: 960px) {
  .uk-width-large-1-1 {
    width: 100%;
  }
  .uk-width-large-1-2,
  .uk-width-large-2-4,
  .uk-width-large-3-6,
  .uk-width-large-5-10 {
    width: 50%;
  }
  .uk-width-large-1-3,
  .uk-width-large-2-6 {
    width: 33.333%;
  }
  .uk-width-large-2-3,
  .uk-width-large-4-6 {
    width: 66.666%;
  }
  .uk-width-large-1-4 {
    width: 25%;
  }
  .uk-width-large-3-4 {
    width: 75%;
  }
  .uk-width-large-1-5,
  .uk-width-large-2-10 {
    width: 20%;
  }
  .uk-width-large-2-5,
  .uk-width-large-4-10 {
    width: 40%;
  }
  .uk-width-large-3-5,
  .uk-width-large-6-10 {
    width: 60%;
  }
  .uk-width-large-4-5,
  .uk-width-large-8-10 {
    width: 80%;
  }
  .uk-width-large-1-6 {
    width: 16.666%;
  }
  .uk-width-large-5-6 {
    width: 83.333%;
  }
  .uk-width-large-1-10 {
    width: 10%;
  }
  .uk-width-large-3-10 {
    width: 30%;
  }
  .uk-width-large-7-10 {
    width: 70%;
  }
  .uk-width-large-9-10 {
    width: 90%;
  }
}
@media (min-width: 1220px) {
  .uk-width-xlarge-1-1 {
    width: 100%;
  }
  .uk-width-xlarge-1-2,
  .uk-width-xlarge-2-4,
  .uk-width-xlarge-3-6,
  .uk-width-xlarge-5-10 {
    width: 50%;
  }
  .uk-width-xlarge-1-3,
  .uk-width-xlarge-2-6 {
    width: 33.333%;
  }
  .uk-width-xlarge-2-3,
  .uk-width-xlarge-4-6 {
    width: 66.666%;
  }
  .uk-width-xlarge-1-4 {
    width: 25%;
  }
  .uk-width-xlarge-3-4 {
    width: 75%;
  }
  .uk-width-xlarge-1-5,
  .uk-width-xlarge-2-10 {
    width: 20%;
  }
  .uk-width-xlarge-2-5,
  .uk-width-xlarge-4-10 {
    width: 40%;
  }
  .uk-width-xlarge-3-5,
  .uk-width-xlarge-6-10 {
    width: 60%;
  }
  .uk-width-xlarge-4-5,
  .uk-width-xlarge-8-10 {
    width: 80%;
  }
  .uk-width-xlarge-1-6 {
    width: 16.666%;
  }
  .uk-width-xlarge-5-6 {
    width: 83.333%;
  }
  .uk-width-xlarge-1-10 {
    width: 10%;
  }
  .uk-width-xlarge-3-10 {
    width: 30%;
  }
  .uk-width-xlarge-7-10 {
    width: 70%;
  }
  .uk-width-xlarge-9-10 {
    width: 90%;
  }
}
@media (min-width: 768px) {
  [class*="uk-push-"],
  [class*="uk-pull-"] {
    position: relative;
  }
  .uk-push-1-2,
  .uk-push-2-4,
  .uk-push-3-6,
  .uk-push-5-10 {
    left: 50%;
  }
  .uk-push-1-3,
  .uk-push-2-6 {
    left: 33.333%;
  }
  .uk-push-2-3,
  .uk-push-4-6 {
    left: 66.666%;
  }
  .uk-push-1-4 {
    left: 25%;
  }
  .uk-push-3-4 {
    left: 75%;
  }
  .uk-push-1-5,
  .uk-push-2-10 {
    left: 20%;
  }
  .uk-push-2-5,
  .uk-push-4-10 {
    left: 40%;
  }
  .uk-push-3-5,
  .uk-push-6-10 {
    left: 60%;
  }
  .uk-push-4-5,
  .uk-push-8-10 {
    left: 80%;
  }
  .uk-push-1-6 {
    left: 16.666%;
  }
  .uk-push-5-6 {
    left: 83.333%;
  }
  .uk-push-1-10 {
    left: 10%;
  }
  .uk-push-3-10 {
    left: 30%;
  }
  .uk-push-7-10 {
    left: 70%;
  }
  .uk-push-9-10 {
    left: 90%;
  }
  .uk-pull-1-2,
  .uk-pull-2-4,
  .uk-pull-3-6,
  .uk-pull-5-10 {
    left: -50%;
  }
  .uk-pull-1-3,
  .uk-pull-2-6 {
    left: -33.333%;
  }
  .uk-pull-2-3,
  .uk-pull-4-6 {
    left: -66.666%;
  }
  .uk-pull-1-4 {
    left: -25%;
  }
  .uk-pull-3-4 {
    left: -75%;
  }
  .uk-pull-1-5,
  .uk-pull-2-10 {
    left: -20%;
  }
  .uk-pull-2-5,
  .uk-pull-4-10 {
    left: -40%;
  }
  .uk-pull-3-5,
  .uk-pull-6-10 {
    left: -60%;
  }
  .uk-pull-4-5,
  .uk-pull-8-10 {
    left: -80%;
  }
  .uk-pull-1-6 {
    left: -16.666%;
  }
  .uk-pull-5-6 {
    left: -83.333%;
  }
  .uk-pull-1-10 {
    left: -10%;
  }
  .uk-pull-3-10 {
    left: -30%;
  }
  .uk-pull-7-10 {
    left: -70%;
  }
  .uk-pull-9-10 {
    left: -90%;
  }
}
.uk-panel {
  display: block;
  position: relative;
}
.uk-panel,
.uk-panel:hover {
  text-decoration: none;
}
.uk-panel:after,
.uk-panel:before {
  content: "";
  display: table;
}
.uk-panel:after {
  clear: both;
}
.uk-panel > :not(.uk-panel-title):last-child {
  margin-bottom: 0;
}
.uk-panel-title {
  margin-top: 0;
  margin-bottom: 15px;
  font-size: 18px;
  line-height: 24px;
  font-weight: 400;
  text-transform: none;
  color: #444;
}
.uk-panel-badge {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
}
.uk-panel-teaser {
  margin-bottom: 15px;
}
.uk-panel-body {
  padding: 15px;
}
.uk-panel-box {
  padding: 15px;
  background: #fafafa;
  color: #444;
  border: 1px solid #ddd;
  border-radius: 4px;
}
.uk-panel-box-hover:hover {
  color: #444;
}
.uk-panel-box .uk-panel-title {
  color: #444;
}
.uk-panel-box .uk-panel-badge {
  top: 10px;
  right: 10px;
}
.uk-panel-box > .uk-panel-teaser {
  margin-top: -16px;
  margin-left: -16px;
  margin-right: -16px;
}
.uk-panel-box > .uk-nav-side {
  margin: 0 -15px;
}
.uk-panel-box-primary {
  background-color: #ebf7fd;
  color: #2d7091;
  border-color: rgba(45, 112, 145, 0.3);
}
.uk-panel-box-primary-hover:hover {
  color: #2d7091;
}
.uk-panel-box-primary .uk-panel-title {
  color: #2d7091;
}
.uk-panel-box-secondary {
  background-color: #fff;
  color: #444;
}
.uk-panel-box-secondary-hover:hover {
  color: #444;
}
.uk-panel-box-secondary .uk-panel-title {
  color: #444;
}
.uk-panel-hover {
  padding: 15px;
  color: #444;
  border: 1px solid transparent;
  border-radius: 4px;
}
.uk-panel-hover:hover {
  background: #fafafa;
  color: #444;
  border-color: #ddd;
}
.uk-panel-hover .uk-panel-badge {
  top: 10px;
  right: 10px;
}
.uk-panel-hover > .uk-panel-teaser {
  margin-top: -16px;
  margin-left: -16px;
  margin-right: -16px;
}
.uk-panel-header .uk-panel-title {
  padding-bottom: 10px;
  border-bottom: 1px solid #ddd;
  color: #444;
}
.uk-panel-space {
  padding: 30px;
}
.uk-panel-space .uk-panel-badge {
  top: 30px;
  right: 30px;
}
.uk-panel + .uk-panel-divider {
  margin-top: 50px !important;
}
.uk-panel + .uk-panel-divider:before {
  content: "";
  display: block;
  position: absolute;
  top: -25px;
  left: 0;
  right: 0;
  border-top: 1px solid #ddd;
}
@media (min-width: 1220px) {
  .uk-panel + .uk-panel-divider {
    margin-top: 70px !important;
  }
  .uk-panel + .uk-panel-divider:before {
    top: -35px;
  }
}
.uk-panel-box .uk-panel-teaser {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  overflow: hidden;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}
.uk-block {
  position: relative;
  box-sizing: border-box;
  padding-top: 20px;
  padding-bottom: 20px;
}
@media (min-width: 768px) {
  .uk-block {
    padding-top: 50px;
    padding-bottom: 50px;
  }
}
.uk-block:after,
.uk-block:before {
  content: "";
  display: table;
}
.uk-block:after {
  clear: both;
}
.uk-block > :last-child {
  margin-bottom: 0;
}
.uk-block-large {
  padding-top: 20px;
  padding-bottom: 20px;
}
@media (min-width: 768px) {
  .uk-block-large {
    padding-top: 50px;
    padding-bottom: 50px;
  }
}
@media (min-width: 960px) {
  .uk-block-large {
    padding-top: 100px;
    padding-bottom: 100px;
  }
}
.uk-block-default {
  background: #fff;
}
.uk-block-muted {
  background: #f9f9f9;
}
.uk-block-primary {
  background: #00a8e6;
}
.uk-block-secondary {
  background: #222;
}
.uk-block-default + .uk-block-default,
.uk-block-muted + .uk-block-muted,
.uk-block-primary + .uk-block-primary,
.uk-block-secondary + .uk-block-secondary {
  padding-top: 0;
}
.md-card.employee-card {
  position: relative;
  /* border-radius: 6px;
    -webkit-backdrop-filter: blur(30px);
    backdrop-filter: blur(30px);
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
    border: solid 1px #cdd2da;
    background-color: #ffffff; */
  cursor: pointer;
  border-radius: 6px;
  -webkit-backdrop-filter: blur(30px);
  backdrop-filter: blur(30px);
  box-shadow: 0 4px 11px 0 rgba(0, 0, 0, 0.15);
  background-color: #00448b;
}
.md-card.employee-card + .md-card.employee-card,
.md-card.employee-card + .uk-grid,
.uk-grid + .md-card.employee-card {
  margin-top: 25px;
}
.md-card.employee-card .full_width_in_card {
  padding: 16px 24px;
  background: rgba(0, 0, 0, 0.085);
}
.md-card.employee-card .md-card-toolbar {
  height: 48px;
  padding: 0 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  background: #fff;
}
.md-card.employee-card .md-card-toolbar:after,
.md-card.employee-card .md-card-toolbar:before {
  content: " ";
  display: table;
}
.md-card.employee-card .md-card-toolbar:after {
  clear: both;
}
.md-card.employee-card .md-card-toolbar:after,
.md-card.employee-card .md-card-toolbar:before {
  content: " ";
  display: table;
}
.md-card.employee-card .md-card-toolbar:after {
  clear: both;
}
.md-card.employee-card .md-card-toolbar-heading-text {
  font: 500 14px/50px Roboto, sans-serif;
  color: #212121;
  margin: 0;
  float: left;
  overflow: hidden;
  height: 48px;
}
.md-card.employee-card .md-card-toolbar-heading-text.large {
  font-size: 18px;
  font-weight: 400;
}
.md-card.employee-card .md-card-toolbar .md-toggle-group {
  float: left;
  margin: 8px 0 0 16px;
}
.md-card.employee-card .md-card-toolbar .md-toggle-group.md-toggle-group-small {
  margin-top: 10px;
}
.md-card.employee-card .md-card-toolbar .md-card-toolbar-actions {
  float: right;
  padding-top: 10px;
}
.md-card.employee-card
  .md-card-toolbar
  .md-card-toolbar-actions
  .uk-open
  .md-card-toolbar-icon {
  background: rgba(0, 0, 0, 0.085);
  color: #212121;
}
.md-card.employee-card
  .md-card-toolbar
  .md-card-toolbar-actions
  .md-card-dropdown {
  display: inline-block;
  position: relative;
}
.md-card.employee-card
  .md-card-toolbar
  .md-card-toolbar-actions
  .selectize-control {
  min-width: 220px;
  margin-top: -3px;
}
.md-card.employee-card
  .md-card-toolbar
  .md-card-toolbar-actions
  .selectize-control
  .selectize-input {
  min-height: 30px;
  padding: 4px 8px;
}
.md-card.employee-card
  .md-card-toolbar
  .md-card-toolbar-actions
  .selectize-control
  .selectize-dropdown {
  margin-top: -34px;
}
.md-card.employee-card .md-card-toolbar .md-icon + .md-card-dropdown {
  margin-left: 4px;
}
.md-card.employee-card .md-card-toolbar .md-card-fullscreen-deactivate {
  margin: 9px 8px 0 0;
}
.md-card.employee-card .md-card-toolbar-input {
  border: none;
  font: 400 18px/24px Roboto, sans-serif;
  height: auto;
  background: 0 0 !important;
  padding: 12px 0;
  width: 50%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.md-card.employee-card .md-card-toolbar .uk-tab {
  margin-top: -2px;
  border-bottom: none;
}
.md-card.employee-card .md-card-toolbar .uk-tab li > a {
  padding: 10px 8px !important;
}
.md-card.employee-card .md-card-head {
  height: 175px;
  position: relative;
  border-bottom: 1px solid transparent;
}
.md-card.employee-card .md-card-head-menu {
  position: absolute;
  right: 8px;
  top: 8px;
}
.profile-img-div {
  background-color: rgba(255, 255, 255, 0);
  width: 86px;
  height: 86px;
  border-radius: 50%;
  margin-top: 20px;
  display: inline-block;
  border: 2px solid;
}
.md-card.employee-card .md-card-head-avatar {
  width: 75px;
  height: 75px;
  border-radius: 50%;
  margin-top: 4px;
  display: inline-block;
  border: 1px solid #1a9347;
  border-radius: 50%;
}
.md-card.employee-card .md-card-head-text {
  padding: 8px 10px 8px;
  font-size: 15px;
  color: #fff;
  margin: 0;
  font-weight: 600;
  line-height: 1.19;
}
.md-card.employee-card .md-card-head-text span:not(.listNavSelector) {
  display: block;
  font-size: 13px;
  margin-top: 5px;
  margin-bottom: 0px;
  color: #fff;
  font-weight: 600;
  line-height: 1.25;
}
.md-card.employee-card .md-card-head-text.text_dark {
  color: #303031 !important;
}
.md-card.employee-card .md-card-head-text-over {
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(rgba(0, 0, 0, 0.65)),
    to(rgba(0, 0, 0, 0))
  );
  background-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.65) 0,
    rgba(0, 0, 0, 0) 100%
  );
}
.md-card.employee-card .md-card-head-subtext {
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  padding: 0 16px;
  text-align: right;
  color: #fff;
}
.md-card.employee-card .md-card-head-subtext span {
  font-size: 26px;
}
.md-card.employee-card .md-card-head-icon {
  font-size: 48px;
  color: #fff;
  vertical-align: middle;
}
.md-card.employee-card .md-card-head.head_background {
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  border-bottom-color: transparent;
}
.md-card.employee-card .md-card-head.head_background .md-card-head-text {
  color: #fff;
}
.md-card.employee-card .md-card-head.head_background_top {
  background-repeat: no-repeat;
  background-position: center top;
}
.md-card.employee-card .md-card-head.head_background_bottom {
  background-repeat: no-repeat;
  background-position: center bottom;
}
.md-card.employee-card .md-card-head .head_chart {
  height: 100px;
  width: 100%;
  position: absolute !important;
  left: 0;
  top: 40px;
}
.md-card.employee-card .md-card-head .fitVid_player {
  width: 100%;
  height: 160px;
  overflow: hidden;
}
.md-card.employee-card .md-card-head-img {
  height: 100%;
  width: auto;
}
.md-card.employee-card .md-card-head iframe {
  height: 160px;
}
.md-card.employee-card .md-card-content {
  padding: 5px 12px 12px;
}
.md-card.employee-card .md-card-content.padding-reset {
  padding: 0;
}
.md-card.employee-card .md-card-content.large-padding {
  padding: 24px 35px;
}
.md-card.employee-card .md-card-content.small-padding {
  padding: 8px;
}
.md-card.md-card-fullscreen-activate {
  cursor: pointer;
}
.md-card.md-card-fullscreen {
  position: fixed;
  z-index: 9998;
  overflow-x: hidden;
  cursor: default;
}
.md-card.md-card-fullscreen .md-card-fullscreen-activate {
  display: none;
}
.md-card.md-card-fullscreen .md-card-fullscreen-hide {
  display: none;
}
.md-card.employee-card .md-card-fullscreen-content {
  display: none;
  padding: 16px;
}
.md-card-fullscreen-content-hidden
  .md-card.employee-card
  .md-card-fullscreen-content {
  display: block;
  visibility: hidden;
  padding: 0;
}
.md-card.mdToolbar_fixed {
  overflow-y: hidden;
}
.md-card.mdToolbar_fixed > .md-card-toolbar {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 9999;
  -webkit-box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16),
    0 3px 6px rgba(0, 0, 0, 0.23);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}
.md-card.mdToolbar_fixed > .md-card-content {
  overflow-y: scroll;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  width: 100%;
  top: 48px;
  bottom: 0;
}
.md-card.mdToolbar_fixed > .md-card-content .md-card-fullscreen-content {
  padding: 16px 0;
}
.md-card.employee-card.md-card-overlay {
  overflow: hidden;
  padding-bottom: 54px;
}
.md-card.employee-card .md-card-overlay .md-card-content {
  height: 142px;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.md-card.employee-card .md-card-overlay .md-card-content.no_truncate {
  position: relative;
}
.md-card.employee-card.md-card-overlay .md-card-content.no_truncate:after {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 8px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(50%, #fff),
    to(rgba(255, 255, 255, 0))
  );
  background-image: linear-gradient(
    to top,
    #fff 50%,
    rgba(255, 255, 255, 0) 100%
  );
  display: block;
  content: "";
  z-index: 10;
}
.md-card.employee-card.md-card-overlay .md-card-content > pre {
  margin-top: 0;
  max-height: 110px;
}
.md-card.employee-card.md-card-overlay .md-card-content > pre > code {
  overflow: hidden;
}
.md-card.employee-card.md-card-overlay .md-card-overlay-content {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  padding: 0 16px;
  margin-top: -54px;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  text-align: left;
  bottom: 0;
  background: #fff;
  z-index: 10;
  -webkit-transition: all 280ms cubic-bezier(0.4, 0, 0.2, 1);
  transition: all 280ms cubic-bezier(0.4, 0, 0.2, 1);
}
.md-card.employee-card.md-card-overlay .md-card-overlay-content p {
  margin: 0;
}
.md-card.employee-card.md-card-overlay .md-card-overlay-content p + * {
  margin-top: 16px;
}
.md-card.employee-card.md-card-overlay .md-card-overlay-content p + p {
  margin-top: 4px;
}
.md-card.employee-card.md-card-overlay .md-card-overlay-header {
  padding: 12px 0;
}
.md-card.employee-card.md-card-overlay .md-card-overlay-header:after,
.md-card.employee-card.md-card-overlay .md-card-overlay-header:before {
  content: " ";
  display: table;
}
.md-card.employee-card.md-card-overlay .md-card-overlay-header:after {
  clear: both;
}
.md-card.employee-card.md-card-overlay .md-card-overlay-header:after,
.md-card.employee-card.md-card-overlay .md-card-overlay-header:before {
  content: " ";
  display: table;
}
.md-card.employee-card.md-card-overlay .md-card-overlay-header:after {
  clear: both;
}
.md-card.employee-card.md-card-overlay .md-card-overlay-header h3,
.md-card.employee-card.md-card-overlay .md-card-overlay-header h4 {
  margin: 0;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: top;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
  padding-right: 32px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.md-card.employee-card.md-card-overlay .md-card-overlay-header .md-icon {
  position: absolute;
  right: 12px;
  top: 11px;
}
.md-card.employee-card.md-card-overlay-active .md-card-overlay-content {
  top: -1px;
  margin-top: 0;
}
/* .md-card.md-card-hover{
    -webkit-transition:all 280ms cubic-bezier(.4,0,.2,1);
    transition:all 280ms cubic-bezier(.4,0,.2,1);
    will-change:box-shadow
}
.md-card.md-card-hover:hover{
    -webkit-box-shadow:0 10px 20px rgba(0,0,0,.19),0 6px 6px rgba(0,0,0,.23);
    box-shadow:0 10px 20px rgba(0,0,0,.19),0 6px 6px rgba(0,0,0,.23)
} */
.uk-sortable-dragged .md-card {
  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19),
    0 6px 6px rgba(0, 0, 0, 0.23);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
}
.uk-sortable-dragged .md-card.employee-card canvas {
  margin: 0 auto;
  display: block;
}
.md-card.employee-card .heading_list {
  padding: 0;
}
.md-card-danger,
.md-card-primary,
.md-card-success,
.md-card-warning {
  border-left: 4px solid transparent;
}
.md-card-primary {
  border-left-color: #00448b;
}
.md-card-success {
  border-left-color: #7cb342;
}
.md-card-danger {
  border-left-color: #e53935;
}
.md-card-warning {
  border-left-color: #ffa000;
}
.md-card-horizontal {
  position: relative;
  min-height: 200px;
}
.md-card-horizontal:after,
.md-card-horizontal:before {
  content: " ";
  display: table;
}
.md-card-horizontal:after {
  clear: both;
}
.md-card-horizontal:after,
.md-card-horizontal:before {
  content: " ";
  display: table;
}
.md-card-horizontal:after {
  clear: both;
}
.md-card-horizontal-grid {
  min-height: auto;
}
.md-card-horizontal .md-card-head {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  border-bottom: none;
  width: 200px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
}
@media only screen and (max-width: 767px) {
  .md-card-horizontal .md-card-head {
    width: 140px;
  }
}
.md-card-horizontal .md-card-head-grid {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}
.md-card-horizontal .md-card-head-menu {
  right: auto;
  left: 8px;
}
.md-card-horizontal .md-card-content {
  margin-left: 200px;
}
@media only screen and (max-width: 767px) {
  .md-card-horizontal .md-card-content {
    margin-left: 140px;
  }
}
.md-card-horizontal .md-card-content-grid {
  padding: 16px;
}
.md-expand,
.md-expand-group > * {
  opacity: 0;
}
.md-card-placeholder {
  min-width: 100%;
}
.md-card-list-wrapper,
.md-card-list-wrapper *,
.md-card-list-wrapper :after,
.md-card-list-wrapper :before,
.md-card-list-wrapper:after,
.md-card-list-wrapper:before {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.md-card-list-wrapper .md-card-list-header {
  position: absolute;
  top: -24px;
  left: 0;
}
.md-card-list-wrapper .md-card-list {
  margin: 48px 0 0 0;
  position: relative;
}
.md-card-list-wrapper .md-card-list:first-child {
  margin-top: 24px;
}
.md-card-list-wrapper .md-card-list > ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.md-card-list-wrapper .md-card-list > ul > li {
  padding: 0;
  margin: 0;
  list-style: none;
}
.md-card-list-wrapper .md-card-list > ul > li {
  min-height: 34px;
  padding: 8px 16px;
  font-size: 13px;
  -webkit-transition: background 150ms, padding 0.2s;
  transition: background 150ms, padding 0.2s;
  background: #fff;
  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12),
    0 1px 2px rgba(0, 0, 0, 0.24);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
.md-card-list-wrapper .md-card-list > ul > li:after,
.md-card-list-wrapper .md-card-list > ul > li:before {
  content: " ";
  display: table;
}
.md-card-list-wrapper .md-card-list > ul > li:after {
  clear: both;
}
.md-card-list-wrapper .md-card-list > ul > li:after,
.md-card-list-wrapper .md-card-list > ul > li:before {
  content: " ";
  display: table;
}
.md-card-list-wrapper .md-card-list > ul > li:after {
  clear: both;
}
.md-card-list-wrapper .md-card-list > ul > li.item-shown {
  background: #fff;
  padding: 8px 36px;
}
@media only screen and (max-width: 767px) {
  .md-card-list-wrapper
    .md-card-list
    > ul
    > li.item-shown
    .md-card-list-item-subject {
    clear: both;
    float: none;
    padding-top: 16px;
  }
  .md-card-list-wrapper
    .md-card-list
    > ul
    > li.item-shown
    .md-card-list-item-subject
    > span {
    white-space: normal;
  }
}
.md-card-list-wrapper
  .md-card-list
  > ul
  > li.item-shown
  .md-card-list-item-sender {
  width: auto;
  overflow: hidden;
}
.md-card-list-wrapper
  .md-card-list
  > ul
  > li.item-shown.md-card-list-item-selected {
  position: relative;
}
.md-card-list-wrapper
  .md-card-list
  > ul
  > li.item-shown.md-card-list-item-selected:before {
  content: "";
  position: absolute;
  display: block;
  left: 0;
  top: 0;
  bottom: 0;
  width: 8px;
  background: #e3f2fd;
}
.md-card-list-wrapper .md-card-list .md-card-list-item-avatar-wrapper,
.md-card-list-wrapper .md-card-list .md-card-list-item-select,
.md-card-list-wrapper .md-card-list .md-card-list-item-sender {
  float: left;
}
.md-card-list-wrapper .md-card-list .md-card-list-item-select {
  padding: 6px 8px 0 0;
}
.md-card-list-wrapper .md-card-list .md-card-list-item-avatar-wrapper,
.md-card-list-wrapper .md-card-list .md-card-list-item-date,
.md-card-list-wrapper .md-card-list .md-card-list-item-sender,
.md-card-list-wrapper .md-card-list .md-card-list-item-subject {
  padding: 0 8px;
}
.md-card-list-wrapper
  .md-card-list
  .md-card-list-item-avatar-wrapper
  .md-card-list-item-avatar {
  background: #757575;
  color: #fff;
  width: 34px;
  border-radius: 50%;
  display: block;
}
.md-card-list-wrapper
  .md-card-list
  .md-card-list-item-avatar-wrapper
  .md-card-list-item-avatar-large {
  width: 82px;
  border-radius: 50%;
}
.md-card-list-wrapper
  .md-card-list
  .md-card-list-item-avatar-wrapper
  span.md-card-list-item-avatar {
  line-height: 34px;
  text-transform: uppercase;
  text-align: center;
}
.md-card-list-wrapper .md-card-list .md-card-list-item-sender {
  width: 220px;
  line-height: 34px;
}
.md-card-list-wrapper .md-card-list .md-card-list-item-sender > span {
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: top;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
}
@media only screen and (max-width: 1219px) {
  .md-card-list-wrapper .md-card-list .md-card-list-item-sender {
    display: none;
  }
}
.md-card-list-wrapper .md-card-list .md-card-list-item-subject {
  overflow: hidden;
  font-weight: 500;
}
.md-card-list-wrapper .md-card-list .md-card-list-item-subject > span {
  line-height: 34px;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: top;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
}
.md-card-list-wrapper
  .md-card-list
  .md-card-list-item-subject
  .md-card-list-item-sender-small {
  display: none;
}
@media only screen and (max-width: 1219px) {
  .md-card-list-wrapper
    .md-card-list
    .md-card-list-item-subject
    .md-card-list-item-sender-small {
    display: block;
  }
  .md-card-list-wrapper
    .md-card-list
    .md-card-list-item-subject
    .md-card-list-item-sender-small
    + span {
    line-height: inherit;
  }
}
.md-card-list-wrapper
  .md-card-list
  .md-card-list-item-subject
  .md-card-list-item-sender-small
  > span {
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: top;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
  font-size: 12px;
  color: #999;
}
.md-card-list-wrapper .md-card-list .md-card-list-item-date {
  line-height: 34px;
  float: right;
  color: #999;
}
@media only screen and (max-width: 479px) {
  .md-card-list-wrapper .md-card-list .md-card-list-item-date {
    display: none;
  }
}
.md-card-list-wrapper .md-card-list .md-card-list-item-menu {
  float: right;
  margin: 0 0 0 8px;
  position: relative;
}
.md-card-list-wrapper
  .md-card-list
  .md-card-list-item-menu
  .uk-dropdown
  .material-icons {
  margin-right: 8px;
}
.md-card-list-wrapper .md-card-list .md-card-list-item-content-wrapper {
  display: none;
  clear: both;
  opacity: 0;
}
.md-card-list-wrapper .md-card-list .md-card-list-item-content {
  padding: 16px 16px 0 0;
  max-height: 360px;
  overflow-x: hidden;
  margin: 0 0 40px;
  top: 20px;
  position: relative;
  font-size: 14px;
}
.md-card-list-wrapper
  .md-card-list
  .md-card-list-item-content
  + .md-card-list-item-reply {
  padding-top: 10px;
}
.md-card-list-wrapper .md-card-list .md-card-list-item-reply {
  padding: 16px 0;
}
.md-card-list-wrapper .md-card-list .md-card-list-item-selected {
  background: #e3f2fd;
}
.md-list {
  margin: 0;
  padding: 0;
  list-style: none;
}
.md-list > li {
  padding: 0;
  margin: 0;
  list-style: none;
}
.md-list,
.md-list *,
.md-list :after,
.md-list :before,
.md-list:after,
.md-list:before {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.md-list .uk-nestable-list > li,
.md-list > li {
  min-height: 48px;
  padding: 8px 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  position: relative;
}
.md-list .uk-nestable-list > li > .md-list-content,
.md-list > li > .md-list-content {
  overflow: hidden;
}
.md-list .uk-nestable-list > li > .md-list-content > span,
.md-list > li > .md-list-content > span {
  display: block;
}
.md-list .uk-nestable-list > li > .md-list-content .md-list-heading,
.md-list > li > .md-list-content .md-list-heading {
  margin: 0;
  font-weight: 500;
  display: block;
  overflow: hidden;
  padding-bottom: 1px;
}
.md-list .uk-nestable-list > li > .md-list-content .md-list-menu,
.md-list > li > .md-list-content .md-list-menu {
  float: right;
}
.md-list
  .uk-nestable-list
  > li
  > .md-list-content
  .md-list-menu
  .md-list-menu-toggle,
.md-list > li > .md-list-content .md-list-menu .md-list-menu-toggle {
  display: block;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.8);
  width: 28px;
  height: 28px;
  line-height: 28px;
  border-radius: 14px;
  text-align: center;
}
.md-list .uk-nestable-list > li > .md-list-content .uk-badge,
.md-list > li > .md-list-content .uk-badge {
  float: right;
  color: #fff !important;
}
.md-list .uk-nestable-list > li > .md-list-content .md-list-action,
.md-list > li > .md-list-content .md-list-action {
  float: right;
  margin-left: 8px;
  margin-top: 2px;
  display: none;
}
.md-list .uk-nestable-list > li > .md-list-content .md-list-action-placeholder,
.md-list > li > .md-list-content .md-list-action-placeholder {
  float: right;
  margin-left: 8px;
  display: none;
  width: 32px;
  height: 32px;
}
.md-list .uk-nestable-list > li .md-list-action-dropdown,
.md-list > li .md-list-action-dropdown {
  position: absolute;
  right: 16px;
  top: 10px;
  display: none;
}
.md-list .uk-nestable-list > li > a.md-list-content,
.md-list > li > a.md-list-content {
  display: block;
  color: #212121;
}
.md-list .uk-nestable-list > li:last-child,
.md-list > li:last-child {
  border-bottom: none;
}
.md-list .uk-nestable-list > li.md-list-item-active,
.md-list > li.md-list-item-active {
  color: #7cb342;
  background: #ededed;
}
.md-list .uk-nestable-list > li.md-list-item-disabled > .md-list-content,
.md-list > li.md-list-item-disabled > .md-list-content {
  color: #bdbdbd;
}
.md-list .uk-nestable-list > li.md-list-item-disabled > .md-list-content span,
.md-list > li.md-list-item-disabled > .md-list-content span {
  color: #bdbdbd !important;
}
.md-list .uk-nestable-list > li.heading_list,
.md-list > li.heading_list {
  min-height: 32px;
  padding: 32px 8px 16px;
  border-bottom: none;
  background: 0 0 !important;
  text-transform: uppercase;
}
.md-list
  .uk-nestable-list
  > li:hover
  > .md-list-addon-element
  .uk-nestable-handle,
.md-list > li:hover > .md-list-addon-element .uk-nestable-handle,
.uk-touch
  .md-list
  .uk-nestable-list
  > li
  > .md-list-addon-element
  .uk-nestable-handle,
.uk-touch .md-list > li > .md-list-addon-element .uk-nestable-handle {
  display: block;
}
.md-list .uk-nestable-list > li:hover > .md-list-content .md-list-action,
.md-list
  .uk-nestable-list
  > li:hover
  > .md-list-content
  .md-list-action-placeholder,
.md-list > li:hover > .md-list-content .md-list-action,
.md-list > li:hover > .md-list-content .md-list-action-placeholder,
.uk-touch .md-list .uk-nestable-list > li > .md-list-content .md-list-action,
.uk-touch
  .md-list
  .uk-nestable-list
  > li
  > .md-list-content
  .md-list-action-placeholder,
.uk-touch .md-list > li > .md-list-content .md-list-action,
.uk-touch .md-list > li > .md-list-content .md-list-action-placeholder {
  display: block;
}
.md-list .uk-nestable-list > li:hover .md-list-action-dropdown,
.md-list > li:hover .md-list-action-dropdown,
.uk-touch .md-list .uk-nestable-list > li .md-list-action-dropdown,
.uk-touch .md-list > li .md-list-action-dropdown {
  display: block;
}
.md-list .uk-nestable-list > li {
  margin-left: 64px;
}
.md-list-addon > li {
  margin-left: 64px;
  position: relative;
}
.md-list-addon > li:last-child .md-list-addon-element {
  border-bottom: none;
  bottom: 0;
}
.md-list-addon > li:first-child .md-list-addon-element {
  top: 0;
}
.md-list-addon > li.md-list-item-active .md-list-addon-element,
.md-list-addon > li.md-list-item-active .md-list-addon-element .material-icons {
  color: #7cb342;
}
.md-list-addon-element {
  position: absolute;
  left: -64px;
  top: -1px;
  bottom: -1px;
  width: 64px;
  text-align: center;
  padding: 8px 0;
  display: block;
}
.md-list-addon-element .element-status {
  position: absolute;
  right: 12px;
  top: 10px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #bdbdbd;
  border: 1px solid #fff;
}
.md-list-addon-element .element-status-danger {
  background: #e53935;
}
.md-list-addon-element .element-status-success {
  background: #7cb342;
}
.md-list-addon-element .element-status-warning {
  background: #ffa000;
}
.md-list-addon-element > .md-list-addon-avatar {
  margin-top: 2px;
}
.md-list-addon-element > .md-list-addon-icon {
  font-size: 28px;
  margin-top: 4px;
  color: #727272;
}
.md-list-addon-element > .material-icons {
  margin-top: 6px;
}
.md-list-addon-element .icheckbox_md,
.md-list-addon-element .iradio_md {
  margin-top: 10px;
}
.md-list-addon-element .uk-nestable-handle {
  position: absolute;
  left: -2px;
  top: 12px;
  display: none;
}
.md-list-interactive li {
  cursor: pointer;
}
.md-list-bg {
  background: #fff;
}
.md-list-separated li {
  background: #fff;
  padding: 8px;
}
.md-list-separated li + li {
  border-top: none;
  margin-top: 8px;
}
.md-list-bg-no-sep {
  background: #fff;
  padding: 8px;
}
.md-list-bg-no-sep li > .md-list-content {
  padding: 0 4px;
}
.md-list-outside > li {
  padding: 0;
}
.md-list-outside > li > .md-list-content {
  padding: 8px 16px;
  display: block;
  color: #212121;
}
.md-list-outside > li.md-list-item-active,
.md-list-outside > li:hover:not(.heading_list) {
  background: rgba(0, 0, 0, 0.085);
}
.md-list-outside > li.heading_list {
  padding: 32px 16px 16px;
}
.md-list-outside.md-list-addon li {
  margin-left: 0;
}
.md-list-outside.md-list-addon li .md-list-addon-element {
  position: relative;
  top: auto;
  left: auto;
  float: left;
}
.md-list-outside.md-list-addon li .md-list-content {
  padding-left: 0;
}
.md-list-outside-wrapper {
  position: relative;
}
.md-list-outside-wrapper .md-list-outside-search {
  position: absolute;
  top: -46px;
  left: 16px;
  right: 16px;
  z-index: 1000;
}
.md-list-outside-wrapper .md-list-outside-search .md-input-wrapper {
  padding: 0;
}
.md-list-outside-wrapper
  .md-list-outside-search
  .md-input-wrapper
  .md-input-bar:after,
.md-list-outside-wrapper
  .md-list-outside-search
  .md-input-wrapper
  .md-input-bar:before {
  background: #fff;
}
.md-list-outside-wrapper .md-list-outside-search .md-input {
  border-bottom-color: transparent !important;
}
.md-list .uk-nestable-list {
  padding-left: 0;
}
.md-list .uk-nestable-list .uk-nestable-item {
  padding-right: 0;
}
.md-list .uk-nestable-item + .uk-nestable-item {
  margin-top: 0;
}
.md-list-right.md-list-addon > li {
  margin-left: 0;
  margin-right: 64px;
}
.md-list-right.md-list-addon > li .md-list-addon-element {
  left: auto;
  right: -64px;
}
.uk-touch .md-list-addon-element .uk-nestable-handle {
  display: block !important;
}
.uk-touch .md-list-content .md-list-action,
.uk-touch .md-list-content .md-list-action-placeholder {
  display: block !important;
}
.uk-touch .md-list-action-dropdown {
  display: block !important;
}

.card-box.employee-box {
  box-sizing: border-box;
  padding-left: 15px;
  padding-bottom: 20px;
  display: inline-block;
  width: 260px;
}
.pink-box {
  box-shadow: 0 2px 10px 0 rgba(255, 38, 138, 0.55);
  background-color: #ff268a;
}
.blue-box {
  box-shadow: 0 2px 10px 0 rgba(13, 132, 242, 0.36);
  background-color: #00448b;
}
.lightblue-box {
  box-shadow: 0 2px 10px 0 rgba(13, 132, 242, 0.36);
  background-color: #50bcff;
}
.orange-box {
  box-shadow: 0 2px 10px 0 rgba(245, 166, 35, 0.35);
  background-color: #f5a623;
}
.border-orange1 {
  border-color: #ff7f00 !important;
}
.border-green1 {
  border-color: #1a9347 !important;
}
.border-red1 {
  border-color: #e82828 !important;
}
.border-blue1 {
  border-color: #00448b !important;
}
.border-white1 {
  border-color: #fff !important;
}
.card-group {
  margin-bottom: 2.143rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
}
.card-block {
  position: relative;
  padding: 1.429rem;
  -webkit-box-flex: 1;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}
.card.card-block {
  box-shadow: none;
}
@media (min-width: 480px) {
  .card-group {
    -webkit-flex-flow: row wrap;
    -ms-flex-flow: row wrap;
    flex-flow: row wrap;
  }
  .card-group .card:first-child {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group .card {
    margin-bottom: 0;
    -webkit-box-flex: 1;
    -webkit-flex: 1 0 0%;
    -ms-flex: 1 0 0%;
    flex: 1 0 0%;
  }
}
.counter {
  text-align: center;
}
.vertical-align:before {
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  content: "";
}
.vertical-align-bottom,
.vertical-align-middle {
  display: inline-block;
  max-width: 100%;
  font-size: 1rem;
}
.vertical-align-middle {
  vertical-align: middle;
}
.counter-lg .counter-icon {
  font-size: 40px;
}
.counter-inverse .counter-icon {
  color: #00448b;
}
.counter-inverse {
  color: #303031;
}
.h-150 {
  height: 150px !important;
}
.modal-qr-block {
  width: 100%;
  position: relative;
  display: block;
  padding: 20px 10px 0px;
  text-align: center;
}
.modal-passport-block {
  width: 100%;
  position: relative;
  display: block;
  padding: 5px 10px 0px;
}
.option__image {
  max-height: 80px;
  margin-right: 10px;
}
.option__desc,
.option__image {
  display: inline-block;
  vertical-align: middle;
}
.option__desc {
  padding: rem(10px);
}
.option__title {
  font-size: rem(24px);
}
.option__small {
  margin-top: rem(10px);
  display: block;
}
.form__label {
  margin-top: 5px !important;
}
.badge__img {
  vertical-align: middle;
  float: right;
}
.badge__name {
  vertical-align: middle;
  margin-left: 5px;
  float: left;
}
.employee-section {
  font-weight: bold;
  line-height: 1.22;
  color: #303031;
  margin-top: 0px;
  margin-bottom: 30px;
  text-align: left;
  padding-top: 0px;
  padding-bottom: 20px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 230px));
  gap: 1rem;
  max-height: 63em;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-flow: row !important;
  flex-wrap: wrap !important;
}
.employeeheader {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  min-height: 40px;
  height: 100%;
  position: relative;
  background: #ffffff;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.employeeheader > .descriptionheader {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 16px 25px;
  border-bottom: 1px solid transparent;
}
.employeeheader > .descriptionheader .description-text-header-left h5 {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  color: #00448b;
}
.employeeheader > .descriptionheader .description-text-header-right {
  font-size: 13px;
  margin-left: auto;
  padding-left: 12px;
  color: #4e5764;
  font-weight: 500;
}
.employeeheader > .descriptionheader .description-text-header-right {
  display: block;
  margin-top: 30px;
}
.see-link {
  text-decoration: underline;
  font-size: 13px;
  font-weight: normal;
  line-height: 1.2;
  color: #00448b;
  cursor: pointer;
  float: right;
}
.btn-outline-danger:hover {
  color: #fff !important;
  background-color: #f44336;
  border-color: #f44336;
}
.btn-outline-danger {
  color: #f44336 !important;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.btn-secondary.btn-outline {
  color: #00448b !important;
  background-color: transparent;
  background-image: none;
  border: 1px solid #00448b;
}
.btn-secondary.btn-outline:hover {
  color: #fff !important;
  background-color: #00448b;
  border-color: #00448b;
}
.btn-outline-default:hover,
.btn-outline-default:active {
  color: #fff !important;
  background-color: #4e5764;
  border-color: #4e5764;
}
.btn-outline-default {
  color: #4e5764 !important;
  background-color: transparent;
  background-image: none;
  border-color: #4e5764;
}
/* .nav-pills.nav-employees .nav-link.active,
.nav-pills.nav-employees .show>.nav-link {
    color: #fff;
    background-color: #00448b;
} */
.nav-pills.nav-employees .nav-link {
  -webkit-border-radius: 18px;
  border-radius: 18px;
}
.nav-pills.nav-employees .nav-link {
  height: 32px;
  color: #00448b;
  text-decoration: none;
  border: 1px solid #00448b;
  line-height: 32px;
  margin-right: 10px;
}
/* .nav-pills.nav-employees .nav-link:hover,
.nav-pills.nav-employees .nav-link:focus {
    text-decoration: none;
    color: #fff !important;
    background-color: #00448b;
} */
.tab-content.employee-tab-content {
  padding: 10px 0px;
}
.nav-pills.nav-employees .nav-link.acceptedtab.active,
.nav-pills.nav-employees .nav-item.acceptedtab.show .nav-link {
  border-color: #1a9347;
  background-color: #1a9347;
  color: #fff;
}
.nav-pills.nav-employees .nav-link.acceptedtab:hover,
.nav-pills.nav-employees .nav-link.acceptedtab:focus {
  text-decoration: none;
  color: #fff !important;
  background-color: #1a9347;
  border-color: #1a9347;
}
.nav-pills.nav-employees .nav-link.pendingtab.active,
.nav-pills.nav-employees .nav-item.pendingtab.show .nav-link {
  border-color: #f8bd59;
  background-color: #f8bd59;
  color: #fff;
}
.nav-pills.nav-employees .nav-link.pendingtab:hover,
.nav-pills.nav-employees .nav-link.pendingtab:focus {
  text-decoration: none;
  color: #fff !important;
  background-color: #f8bd59;
  border-color: #f8bd59;
}
.nav-pills.nav-employees .nav-link.rejectedtab.active,
.nav-pills.nav-employees .nav-item.rejectedtab.show .nav-link {
  border-color: #e82828;
  background-color: #e82828;
  color: #fff;
}
.nav-pills.nav-employees .nav-link.rejectedtab:hover,
.nav-pills.nav-employees .nav-link.rejectedtab:focus {
  text-decoration: none;
  color: #fff !important;
  background-color: #e82828;
  border-color: #e82828;
}
.employeeSearch {
  overflow-y: auto;
  min-height: 100px;
  max-height: 300px;
  overflow-x: hidden;
}
.employeeSearchResult {
  overflow-y: auto;
  min-height: 75px;
  max-height: 300px;
  overflow-x: hidden;
}
.employeeSearch .contact {
  min-height: 60px;
}

.employeeSearch .contact:last-child {
  margin-bottom: 40px;
}
.avatar.avatar-grey {
  background-color: #cdd2da;
  font-size: 16px !important;
  font-weight: 600 !important;
  letter-spacing: 0.28px;
  color: #ffffff;
  width: 40px !important;
  min-width: 40px !important;
  height: 40px !important;
  line-height: 40px !important;
}
.input-search-rounded-box-employee {
  position: relative;
}
.input-search-rounded-box-employee .input-search-close,
.input-search-rounded-box-employee .input-search-icon {
  position: absolute;
  top: 50%;
  z-index: 1;
  width: 2.573rem;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
}
.input-search-rounded-box-employee .input-search-icon {
  left: 2px;
  font-size: 24px;
  color: #9e9e9e;
  text-align: center;
  pointer-events: none;
}
.input-search-rounded-box-employee .input-search-icon + .form-control {
  padding-left: 38px !important;
}
.input-search-rounded-box-employee .form-control {
  border-radius: 0px !important;
}
.input-search-close.icon {
  font-size: inherit !important;
  line-height: inherit !important;
}
button.input-search-close {
  -webkit-appearance: none !important;
  padding: 0 !important;
  cursor: pointer !important;
  background: 0 0 !important;
  border: 0 !important;
}
.input-search-rounded-box-employee .input-search-close {
  right: 8px !important;
  color: #cdd2da !important;
  font-size: 21px !important;
  width: 18px !important;
  height: 18px !important;
  line-height: 18px !important;
}
.input-search-rounded-box-employee .form-control {
  height: 34px !important;
  -webkit-appearance: none !important;
  border-color: #e0e0e0 !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  -moz-appearance: none !important;
}
.input-search-rounded-box-employee .form-control {
  display: block !important;
  width: 100% !important;
  padding: 0.429rem 1.072rem !important;
  font-size: 14px !important;
  line-height: 1.571429 !important;
  color: #4e5764 !important;
  background-color: #fff !important;
  border: 0px;
  border-bottom: solid 1px #00448b !important;
}
.input-search-rounded-box-employee .form-control:focus {
  border-bottom: solid 1px #00448b !important;
}
.searchfooter {
  height: 40px;
  box-shadow: 0 -3px 4px 0 rgba(0, 0, 0, 0.16);
  background-color: #e5e5e5;
  line-height: 40px;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.51px;
  color: #4e5764;
  display: block;
  position: absolute;
  bottom: 0px;
  width: 100%;
}
.searchfooter:hover {
  color: #00448b;
}
.search-user-employee-blocks {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  width: 100%;
}
.employeeSearch .contact .search-user-employee-blocks .mailtext,
.employeeSearch .contact .search-user-employee-blocks .user-employee-name {
  width: 200px;
}

.searchTitle {
  top: 0px;
  position: relative;
  color: #fff !important;
}

.dropdown-employee {
  width: 420px;
  min-height: 100px;
  max-height: 390px;
  margin: 0.25rem 0 0 !important;
  overflow-y: auto;
  border-radius: 11px !important;
  padding: 0rem 0 !important;
  position: absolute;
  left: -20px !important;
  z-index: 99;
  cursor: pointer;
  box-shadow: -5px 5px 7px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
}
.dropdown-employee-search {
  width: 420px;
  min-height: 72px;
  max-height: 390px;
  margin: 0.25rem 0 0 !important;
  overflow-y: auto;
  border-radius: 11px !important;
  padding: 0rem 0 !important;
  position: absolute;
  left: -20px !important;
  z-index: 99;
  cursor: pointer;
  box-shadow: -5px 5px 7px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
}
.dropdown-toggle.employee-toggle.pointer.btn.btn-link:hover i {
  background-color: #00448b;
  color: #fff;
  border-radius: 50%;
}
.dropdown-toggle.employee-toggle.pointer.btn.btn-link:active i {
  background-color: #00448b;
  color: #fff;
  border-radius: 50%;
  border: 1px solid #00448b;
}
.searchContentEmployeeList {
  background-color: transparent;
  color: #00448b;
  font-size: 30px;
  width: 32px;
  height: 32px;
  line-height: 30px;
}
.dropdown-toggle.employee-toggle::after {
  content: none !important;
}
.page-header-search {
  height: 5.6rem;
  min-height: 5.6rem;
  max-height: 5.6rem;
}
@media (max-width: 943px) {
  #myTab li {
    margin: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EmployeeList.vue